// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	function updatePropertyDropdown(site_id){
		switch( site_id ){
			case "2480":
				property_dropdown.value = "Hotel Zetta"
				break
			case "2482":
				property_dropdown.value = "Hotel Zelos"
				break
			case "2481":
				property_dropdown.value = "Hotel Zeppelin"
				break
		}
	}

	let property_dropdown = document.querySelector( ".email-signup [name=property]" )
	if( property_dropdown ){
		
		updatePropertyDropdown(site_id)

		property_dropdown.addEventListener( "change", (e) => {
			let value = e.target.value
			let _additional_email_service = document.querySelector( "[name=_additional_email_service]" )
			switch( value ){
				case "Hotel Zetta":
					_additional_email_service.value = "revinate_zetta"
					break;
				case "Hotel Zelos":
					_additional_email_service.value = "revinate_zelos"
					break;
				case "Hotel Zeppelin":
					_additional_email_service.value = "revinate_zeppelin"
					break;
			}
		} )

	}

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		OBSERVER TO ADD PARALLAX EFFECT
		*****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		END OF OBSERVER TO ADD PARALLAX EFFECT
		***********************************************************************************/
	}

	/* Menu Site */
	let Body = document.body;

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	document.addEventListener('DOMContentLoaded', () => {

		////***** BOOKING WIDGET BRAND *****////
		let bookingBrand = document.getElementById('container-booking-widget-brand');
        if(bookingBrand){
            let actualDay = new Date();
            let actualDayMore = new Date();
            actualDayMore.setDate(actualDay.getDate() + 3);	
            let checkInBooking = document.getElementById('check-in');
            let checkOutBooking = document.getElementById('check-out');
            let selectPropertyBooking = document.getElementById('select_property_booking');
            let bookingWidget = document.getElementById('booking-widget-brand');
			let datesBooking = document.getElementById('dates_fake_booking');

			let room = document.getElementById('select_rooms_booking');
			let guest = document.getElementById('select_guests_booking');

            flatpickr.localize({
                rangeSeparator: " - "
            });

			let url = selectPropertyBooking.value;
			let arrive = actualDay.getFullYear()+'-'+((actualDay.getMonth()+1) <= 9 ? '0' + (actualDay.getMonth()+1) : (actualDay.getMonth()+1))+'-'+actualDay.getDate();
			let depart = actualDayMore.getFullYear()+'-'+((actualDayMore.getMonth()+1) <= 9 ? '0' + (actualDayMore.getMonth()+1) : (actualDayMore.getMonth()+1))+'-'+actualDayMore.getDate();
			let rooms = room.value;
			let adult = guest.value;

			let urlBooking = url+'&rooms='+rooms+'&arrive='+arrive+'&depart='+depart+'&adult='+adult;
            //bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive+'&depart='+depart+'&adult='+adult);

			let flatpickrBooking = document.getElementById('flatpickr_booking');
            flatpickr(flatpickrBooking, {
				mode: 'range',
                showMonths: 2,
                minDate : actualDay,
                dateFormat: 'Y/m/d',
                inline: true,
                defaultDate: {actualDay, actualDayMore},
                onChange: function(selectedDates, dateStr, instance) {
                    let dates = dateStr.split('-');
                    checkInBooking.value = dates[0].trim();
					if (dates[1] != undefined) {
						checkOutBooking.value = dates[1].trim();
						datesBooking.value = dates[0].trim()+' | '+dates[1].trim();

						let mainDay = dates[0].split('/');
						let arYear = mainDay[0];
						let arMon = mainDay[1];
						let arDay = mainDay[2];
						arrive = arYear+'-'+arMon+'-'+arDay;

						let secundDay = dates[1].split('/');
						let depYear = secundDay[0];
						let depMon = secundDay[1];
						let depDay = secundDay[2];
						depart = depYear+'-'+depMon+'-'+depDay;
						
						urlBooking = url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult;
						//bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult);
					} else {
						datesBooking.value = dates[0].trim();

						let mainDay = dates[0].split('/');
						let arYear = mainDay[0];
						let arMon = mainDay[1];
						let arDay = mainDay[2];
						arrive = arYear+'-'+arMon+'-'+arDay;
						
						urlBooking = url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult;
						//bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult);
					}
                }
            });

            selectPropertyBooking.addEventListener('change', ()=>{
                url= selectPropertyBooking.value;
				urlBooking = url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult;
				//bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult);
            });

			room.addEventListener('change', ()=>{
                rooms= room.value;
				urlBooking = url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult;
				//bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult);
            });

			guest.addEventListener('change', ()=>{
                adult= guest.value;
				urlBooking = url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult;
				//bookingWidget.setAttribute('action', url+'&rooms='+rooms+'&arrive='+arrive.trim()+'&depart='+depart.trim()+'&adult='+adult);
            });

			bookingBrand.querySelector('button[type=submit]').addEventListener('click', function(e){
				e.preventDefault();
				window.open(
					urlBooking,
					'_blank'
				);
			});

        }

		/* Menu Site */
		let BookBrand = document.getElementById('book_now_brand');
		let BookBrandBtn = document.getElementById('book_now_brand_button');
		let CloseBrand = document.getElementById('close_book_brand');

		if(BookBrand){
			BookBrand.addEventListener('click', function(e){
				e.preventDefault();
				bookingBrand.classList.add('open');
				Body.classList.add('scroll-no');
			});
		}
		if(BookBrandBtn){
			BookBrandBtn.addEventListener('click', function(e){
				e.preventDefault();
				bookingBrand.classList.add('open');
				Body.classList.add('scroll-no');
			});
		}

		if(CloseBrand){
			CloseBrand.addEventListener('click', function(e){
				e.preventDefault();
				bookingBrand.classList.remove('open');
				Body.classList.remove('scroll-no');
			});
		}

		/* Main Nav Dropdown */
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				if(primary_nav.querySelector('ul.submenu')){
					primary_nav.querySelector('a').classList.add('has-submenu');
				}
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
				primary_nav.querySelectorAll('.has-submenu').forEach(function(parent){
					parent.addEventListener("click", function(event) {
						event.preventDefault();
						if(this.nextElementSibling.classList.contains('open')){
							this.nextElementSibling.classList.remove('open');
						} else {
							this.nextElementSibling.classList.add('open');
						}
					});
				});
			});
		}

		/* Redirect Selector */
		let selectLocation = document.getElementById('select_location');
		if(selectLocation) {
			selectLocation.addEventListener('change', function(){
				let value = this.value;
				if(value != ""){location.href = value;}
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		const lbxLightbox = new LBX('.js-lbx-lightbox', {
			customClass:'lbx-lightbox',
		});

		const lbxCustom = new LBX('.js-lbx-custom', {
			customClass:'lbx-custom',
		});

		let Height = document.body.offsetHeight;
		let backToTop = document.getElementById('backToTop');
		if(backToTop) {
			if(Height >= 3000){
				backToTop.classList.remove('hidden');
			}
		}

		let inputFormat = document.getElementById('00N6T000009yu3q');
		let altDate = document.getElementById('alt_date');
		if(inputFormat){
			inputForm();
			function inputForm() {
				let value = altDate.value;
				console.log(value);
				value = value.split('-');
				let valYear = value[0];
				let valMon = value[1];
				let valDay = value[2];
				let format = valMon+'/'+valDay+'/'+valYear;
				inputFormat.value = format;
			}
			altDate.addEventListener('input', function(){
				inputForm();
			});
		}

		let aAll = document.querySelectorAll("a");
		if(aAll){
			aAll.forEach(ent => {
				if(ent.getAttribute("href").includes('tel:')){
					ent.classList.add('track-phone');
				}
				if(ent.getAttribute("href").includes('mailto:')){
					ent.classList.add('track-email');
				}
			});
		}

	});

	window.addEventListener("load", function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	});

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	/* Scroll Intro*/
	let ScrollDown = document.getElementsByClassName('js-scrolldown');
	if(ScrollDown.length > 0){
		ScrollDown[0].addEventListener('click', function(){
			animateto('intro');
		});
	}

	/* FAQ */
	let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

	/* Menu Accordion */
	let menuInfo = document.querySelectorAll('.menu-title-info');
    if(menuInfo){
        menuInfo.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    menuInfo.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

	/*MOBILE MENU NAV
    ****************************************************************/

	let Html = document.getElementsByTagName('html')[0];
	let MenuBtn = document.getElementById('menu-btn');
	let CloseMenu = document.querySelectorAll('.close-menu');
	let Navigation = document.querySelectorAll('.navigation');
	let NavUl = document.querySelectorAll('.navigation .inner ul li');
	let NavA = document.querySelectorAll('.navigation .inner ul li a');
	let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

	/* Open Navigation */
	if(MenuBtn){
		MenuBtn.addEventListener('click', function(e){
			Html.classList.add('hide-overflow');
			Navigation[0].classList.add('open');
			NavUl.forEach(function(inner) {
				if(inner.classList.contains('item-open')){
					inner.scrollIntoView(false);
				}
			});
		});

		/* Sub-Navigation */
		/* Open active sub-nav on load */
		NavActive.forEach(function(inner) {
			inner.closest('.inner').classList.add('open');
			inner.parentNode.parentNode.parentNode.parentNode.classList.add('li-open');
			inner.closest('.sub-sub-menu').classList.add('menu-open');
		});

		/* Toggle open/close on tap */
		NavA.forEach(function(entry) {
			if(entry.nextElementSibling){
				entry.classList.add('link-parent');
				let clientChildren = entry.nextElementSibling.querySelector('.submenu');
				if(clientChildren != null){
					let clientHeight = clientChildren.clientHeight;
					if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
						entry.nextElementSibling.classList.add('menu-open');
						entry.nextElementSibling.style.height = clientHeight+'px';
						entry.classList.add('hover-open');
						entry.parentNode.classList.add('li-open');
					}
					entry.addEventListener('click', function(e){
						e.preventDefault();
						if(this.nextElementSibling.classList.contains('menu-open')){
							this.nextElementSibling.classList.remove('menu-open');
							this.nextElementSibling.style.height = '0px';
							this.classList.remove('hover-open');
							this.parentNode.classList.remove('li-open');
						} else {
							NavUl.forEach(function(ul) {
								if(ul.querySelector('.sub-sub-menu')){
									if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
										ul.querySelector('.sub-sub-menu').style.height = '0px';
										ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
										ul.querySelector('.link-parent').classList.remove('hover-open');
										ul.querySelector('.link-parent').parentNode.classList.remove('li-open');
									}
								}
							});
							this.nextElementSibling.classList.add('menu-open');
							this.nextElementSibling.style.height = clientHeight+'px';
							this.classList.add('hover-open');
							this.parentNode.classList.add('li-open');
						}
					});
				}
			}
		});
	}

	/* Close Navigation */
	if(CloseMenu[0]){
		CloseMenu[0].addEventListener('click', function(e){
			Html.classList.remove('hide-overflow');
			Navigation[0].classList.remove('open');
		});
	}

	let notCharge = document.querySelectorAll('.not-charge');
	if (notCharge){
		notCharge.forEach(entry => {
			entry.addEventListener('click', function(event){
				event.preventDefault();
			});
		});
	}

	let screenHeight = document.documentElement.clientHeight;
	let homeTopImg = document.querySelector('.homepage');
	if(homeTopImg){
		homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
			if(screen.width < 600){
				entry.style.height = screenHeight-65+'px';
			} else {
				entry.style.height = screenHeight+'px';
			}
		});
		window.addEventListener("resize", function(){
			screenHeight = document.documentElement.clientHeight;
			homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
				if(screen.width < 600){
					entry.style.height = screenHeight-65+'px';
				} else {
					entry.style.height = screenHeight+'px';
				}
			});
		});
	}

	let aBtn = document.querySelectorAll(".btn:not(:where(.attractions-map__expand, .btn-form, .book-now)), .signup-btn, .btn-send");
	if(aBtn){
		setTimeout(() => {
			aBtn.forEach(function(a_btn) {
				let htmlString = a_btn.innerText;
                a_btn.innerHTML = '<span>'+htmlString+'</span>';
			});
		}, 500);
	}

	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default, .link-parent))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}

})();

function animateto(target){
	var gotoTarget = offset(document.getElementById(target)).top - 160;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	/* check scroll down or up for header styles */
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	let subMenu = document.getElementById('subMenu');
	if(st > 80){
		if (st > lastScrollTop){
			/* downscroll code */
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
				if(subMenu){
					subMenu.classList.add('down');
					subMenu.classList.remove('up');
				}
			}
		} else {
			/* upscroll code */
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
				if(subMenu){
					subMenu.classList.add('up');
					subMenu.classList.remove('down');
				}
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')){
			header.classList.remove('up');
			header.classList.remove('down');
			if(subMenu){
				subMenu.classList.remove('up');
				subMenu.classList.remove('down');
			}
		}
	}

	let SubMenu = document.getElementById('subMenuAnchor');
	if(SubMenu){
		let subPost = document.getElementById('subMenu');
		let subPosition = '';
		if(templateSiteSelected == 'brand'){
			if(document.body.classList.contains('alert_open')){
				subPosition = offset(SubMenu).top - 104;
			} else {
				if(screen.width < 600){
					subPosition = offset(SubMenu).top - 70;
				} else {
					subPosition = offset(SubMenu).top - 74;
				}
			}
		}
		else if(templateSiteSelected == 'hotel'){
			if(document.body.classList.contains('alert_open')){
				subPosition = offset(SubMenu).top - 156;
			} else {
				if(screen.width < 600){
					subPosition = offset(SubMenu).top - 87;
				} else {
					subPosition = offset(SubMenu).top - 116;
				}
			}
		} else {
			if(document.body.classList.contains('alert_open')){
				subPosition = offset(SubMenu).top - 130;
			} else {
				if(screen.width < 600){
					subPosition = offset(SubMenu).top - 70;
				} else {
					subPosition = offset(SubMenu).top - 70;
				}
			}
		}
		if(st > subPosition){
			if(!subPost.classList.contains('floating-up')){
				subPost.classList.add('floating-up');
			}
		} else {
			if(subPost.classList.contains('floating-up')) {
				subPost.classList.remove('floating-up');
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}
/** ADA Removes the aria-label From <span> Elements Within the Calendar **/

document.addEventListener("DOMContentLoaded", () => {
    const spans = document.querySelectorAll(".flatpickr-calendar span[aria-label]");
    
    if (spans.length > 0) {
        spans.forEach(span => {
            span.removeAttribute("aria-label");
        });
    }
});


let footerInputsDate = document.querySelector('#emailSignup input[type=date]');
if(footerInputsDate){
	footerInputsDate.addEventListener("input",  () => {
		if (footerInputsDate.value) {
			footerInputsDate.classList.add('full');
    } else {
			footerInputsDate.classList.remove('full');
		}
	})
}
